<template>
  <div class="inline-block">
    <span :class="setLabeltoStatus(companyOverview.officialstatus.name)">
      {{ companyOverview.officialstatus.name }}
    </span>
    <span
      v-if="companyOverview.officialstatus.name !== companyOverview.simplestatus.name"
      class="ml-2"
      :class="setLabeltoStatus(companyOverview.simplestatus.name)"
    >
      {{ companyOverview.simplestatus.name }}
    </span>
  </div>
</template>

<script>
import toolsMixin from '@/components/reports/ToolsMixin';

export default {
  mixins: [toolsMixin],
  name: 'CompanyStatus',
  props: ['companyOverview'],
};
</script>

<style scoped>
.inline-block {
  display: inline-block;
}

.ml-2 {
  margin-left: 0.5rem;
}
</style>
